import React, { useState } from 'react';

const AdminLogin = ({ onLogin }) => {
  const [step, setStep] = useState('email');
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const sendOtp = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    setMessage('');
    try {
      const res = await fetch('/api/admin-auth.php?action=send-otp', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (data.success) {
        setStep('otp');
        setMessage('認証コードを送信しました');
      } else {
        setMessage(data.message || 'エラーが発生しました');
      }
    } catch { setMessage('エラーが発生しました'); }
    setLoading(false);
  };

  const verifyOtp = async (e) => {
    e.preventDefault();
    if (!otp.trim()) return;
    setLoading(true);
    setMessage('');
    try {
      const res = await fetch('/api/admin-auth.php?action=verify-otp', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, otp }),
      });
      const data = await res.json();
      if (data.success) {
        if (data.token) localStorage.setItem('admin_token', data.token);
        if (data.role) localStorage.setItem('admin_role', data.role);
        if (data.email) localStorage.setItem('admin_email', data.email);
        onLogin();
      } else {
        setMessage(data.message || '認証に失敗しました');
      }
    } catch { setMessage('エラーが発生しました'); }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="bg-white rounded-xl shadow-lg p-8 w-full max-w-sm">
        <h1 className="text-xl font-bold text-center mb-6">SrWith 管理画面</h1>

        {message && (
          <div className={`mb-4 px-4 py-2 rounded-lg text-sm ${message.includes('送信しました') ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
            {message}
          </div>
        )}

        {step === 'email' ? (
          <form onSubmit={sendOtp} className="space-y-4">
            <div>
              <label className="block text-sm font-bold mb-1">メールアドレス</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="管理者メールアドレス"
                className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-blue-500"
                autoFocus
              />
            </div>
            <button type="submit" disabled={loading || !email.trim()}
              className="w-full bg-gray-800 text-white font-bold py-2.5 rounded-lg hover:bg-gray-700 transition-colors disabled:opacity-50">
              {loading ? '送信中...' : '認証コードを送信'}
            </button>
          </form>
        ) : (
          <form onSubmit={verifyOtp} className="space-y-4">
            <p className="text-sm text-gray-600 text-center">{email} に認証コードを送信しました</p>
            <div>
              <label className="block text-sm font-bold mb-1">認証コード</label>
              <input
                type="text"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="6桁の認証コード"
                maxLength={6}
                className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-blue-500 text-center tracking-widest text-lg"
                autoFocus
              />
            </div>
            <button type="submit" disabled={loading || otp.length < 6}
              className="w-full bg-gray-800 text-white font-bold py-2.5 rounded-lg hover:bg-gray-700 transition-colors disabled:opacity-50">
              {loading ? '認証中...' : 'ログイン'}
            </button>
            <button type="button" onClick={() => { setStep('email'); setMessage(''); setOtp(''); }}
              className="w-full text-sm text-gray-500 hover:text-gray-700">
              メールアドレスを変更
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default AdminLogin;
